export default __webpack_public_path__ + "src/envmap/scaled/nz.jpg";